'use strict';

export default class JoinFac {
  static get UID() {
    return 'joinFac';
  }

  constructor($http, BASE_URLS) {
    'ngInject';
    Object.assign(this, { $http, BASE_URLS } );
  }

  getOptions() {
    var url = `${this.BASE_URLS.API}/api/billing/`;

    return this.$http.get(url);
  }

  static factory($http, BASE_URLS) {
    return new JoinFac($http, BASE_URLS);
  }
}

JoinFac.factory.$inject = JoinFac.$inject;



// WEBPACK FOOTER //
// ./~/site_core/src/factories/joinFac.js